import { type SelectOption } from "@revmatics/catalyst";

export const supportedPlatforms: string[] = [
  "Instagram",
  "Facebook",
  "YouTube",
  "Pinterest",
  "TikTok",
];

export const competitorStrengthOptions: SelectOption[] = [
  { value: "strong", label: "Strong Competitor" },
  { value: "moderate", label: "Moderate Competitor" },
  { value: "weak", label: "Weak Competitor" },
];
